import { useIsAdmin } from '../auth';

/**
 * Componente que oculta el menú de administración (Admin, Categories, Tags) 
 * en la página de Announcements para usuarios no administradores.
 */
export const HideAnnouncementsAdminMenu = () => {
  const { isAdmin } = useIsAdmin();

  // Si el usuario es administrador, mostrar todo
  if (isAdmin) {
    return null;
  }

  // Si no es admin, ocultar el menú de tres puntos y opciones de admin
  return (
    <style>
      {`
        /* Ocultar TODOS los botones de acción en el header de InfoCard/Card de Announcements */
        [class*="MuiCardHeader-action"] {
          display: none !important;
        }
        
        /* Ocultar menús que contengan links a admin/categories/tags */
        [class*="MuiMenu"] a[href*="/announcements/admin"],
        [class*="MuiMenu"] a[href*="/announcements/categories"],
        [class*="MuiMenu"] a[href*="/announcements/tags"],
        [class*="MuiPopover"] a[href*="/announcements/admin"],
        [class*="MuiPopover"] a[href*="/announcements/categories"],
        [class*="MuiPopover"] a[href*="/announcements/tags"],
        [class*="MuiList"] a[href*="/announcements/admin"],
        [class*="MuiList"] a[href*="/announcements/categories"],
        [class*="MuiList"] a[href*="/announcements/tags"] {
          display: none !important;
        }
        
        /* Ocultar cualquier MenuItem que lleve a admin */
        [class*="MuiMenuItem"][href*="admin"],
        [class*="MuiMenuItem"][href*="categories"],
        [class*="MuiMenuItem"][href*="tags"] {
          display: none !important;
        }
      `}
    </style>
  );
};
